import { Auth } from '@aws-amplify/auth';
import { CognitoRefreshToken, CognitoUser, CognitoUserAttribute, CognitoUserSession } from 'amazon-cognito-identity-js';

export const cognitoAuth = {
  signIn(username: string, password: string) {
    return Auth.signIn(username, password);
  },

  signUp(input: Parameters<typeof Auth.signUp>[0]) {
    return Auth.signUp(input);
  },

  resendSignUp(username: string) {
    return Auth.resendSignUp(username);
  },

  confirmSignUp(username: string, code: string) {
    return Auth.confirmSignUp(username, code);
  },

  currentSession() {
    return Auth.currentSession();
  },

  currentAuthenticatedUser() {
    return Auth.currentAuthenticatedUser();
  },

  completeNewPassword(user: any, newPassword: string, requiredAttributes: any) {
    return Auth.completeNewPassword(user, newPassword, requiredAttributes);
  },

  changePassword(currentUser: any, oldPassword: string, newPassword: string) {
    return Auth.changePassword(currentUser, oldPassword, newPassword);
  },

  forgotPassword(username: string) {
    return Auth.forgotPassword(username);
  },

  forgotPasswordSubmit(username: string, verificationCode: string, newPassword: string) {
    return Auth.forgotPasswordSubmit(username, verificationCode, newPassword);
  },

  signOut(input?: Parameters<typeof Auth.signOut>[0]) {
    return Auth.signOut(input);
  },

  getUserAttributes(cognitoUser: CognitoUser): Promise<CognitoUserAttribute[]> {
    return new Promise((resolve, reject) => {
      cognitoUser.getUserAttributes((error, attributes) => {
        if (error) {
          reject(error);
          return;
        }

        resolve(attributes ?? []);
      });
    });
  },

  refreshSession(cognitoUser: CognitoUser, refreshToken: CognitoRefreshToken): Promise<CognitoUserSession> {
    return new Promise((resolve, reject) => {
      cognitoUser.refreshSession(refreshToken, (error, session) => {
        if (error) {
          reject(error);
          return;
        }

        if (!session) {
          reject(new Error('Cognito refreshSession completed without a session'));
          return;
        }

        resolve(session);
      });
    });
  },
};
